import {
    IonButton,
    IonButtons,
    IonCard,
    IonIcon,
    IonItem,
    IonItemDivider,
    IonLabel,
    IonList,
    IonSpinner,
    IonText,
    IonTitle,
    IonToolbar,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
    IonContent,
    useIonViewWillEnter,
} from "@ionic/react";
import { addCircleOutline } from "ionicons/icons";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Location } from "../../../@types/location";
import { LocationSearchBar } from "./LocationSearchBar";
import { LocationsSelectorOrganizationFilter } from "./LocationsSelectorOrganizationFilter";
import { LocationsSelectoBusinessAreaFilter } from "./LocationsSelectorBusinessAreaFilter";
import { RootState } from "../../../store/rootReducer";
import { selectLocationsAvailable } from "../../../store/userProfileLocation/selector/selectLocationsAvailable";
import { selectUserProfileLocationFilters } from "../../../store/userProfileLocation/selector/selectUserProfileLocationFilters";
import { clearCreateFilters, setMaxListAvailableIndex, setPreselectLocation, setPreselectAll } from "../../../store/userProfileLocation";

export const LocationsSelector = () => {
    const [isInfiniteDisabled, setInfiniteDisabled] = useState<boolean>(false);
    const dispatch = useDispatch();
    const locations = useSelector(selectLocationsAvailable);
    const maxDataList = useSelector((state: RootState) => state.userProfileLocation.maxListAvailableIndex);
    const state = useSelector((state: RootState) => state.userProfileLocation)
    const createFilters = useSelector(selectUserProfileLocationFilters);

    // Logica para IonInfiniteScroll
    const pushData = () => {
        dispatch(setMaxListAvailableIndex(maxDataList + 20));
    }

    const loadData = (ev: any) => {
        setTimeout(() => {
            pushData();
            ev.target.complete();
            if (locations.length === 10000) {
                setInfiniteDisabled(true);
            }
        }, 500);
    }

    useIonViewWillEnter(() => {
        dispatch(setMaxListAvailableIndex(20));
    });

    const handlePreselectAll = async () => {
        dispatch(setPreselectAll(locations));
      };

    return (
        <IonCard style={{ height: "75vh" }} class="ion-no-margin">
            <IonToolbar>
                <IonTitle size="small" style={{ fontWeight: 500 }}>
                    Disponibles {locations && <span>({locations.length})</span>} {/* Según resultado de búsqueda */}
                </IonTitle>
                <IonButtons slot="end">
                    {!!locations.length && (
                        <IonButton fill="solid" size="small" color="primary" onClick={handlePreselectAll}>
                            <small>Agregar todos</small>
                            <IonIcon icon={addCircleOutline} slot="end" />
                        </IonButton>
                    )}
                </IonButtons>
            </IonToolbar>
            <LocationSearchBar /> {/* SearchBar para buscar las plantas que se asignarán al perfil */}
            <IonCard color="transparent">
                <IonItemDivider>
                    Filtros personalizados
                    {(createFilters.organization.code || createFilters.businessArea.code) && (
                        <IonButtons slot="end">
                            <IonButton color="danger" onClick={() => dispatch(clearCreateFilters())}>
                                Limpiar filtros
                            </IonButton>
                        </IonButtons>
                    )}
                </IonItemDivider>
                <section style={{ display: "flex", overflow: "auto", padding: 6 }}>
                    <LocationsSelectorOrganizationFilter /> {/* Seleccion de filtro por Cliente */}
                    <LocationsSelectoBusinessAreaFilter /> {/* Seleccion de filtro por Área de negocio */}
                </section>
            </IonCard>
            {/* Listado de plantas filtradas. Para que funcione IonInfiniteScroll es necesario darle altura al IonContent */}
            <IonContent style={{ overflow: "scroll", height: "50vh" }}>
                <IonList>
                    {state.findLocationStatus === "succeeded" && locations.slice(0, maxDataList).map((location: Location) => (
                        <IonItem key={location.id}>
                            <IonLabel>
                                <h2 style={{ fontWeight: 700 }}>
                                    <IonText color="primary">{location.name}</IonText>
                                </h2>
                                <h4>
                                    <IonText color="medium" style={{ fontWeight: 500 }}>
                                        {location.code}
                                    </IonText>
                                </h4>
                            </IonLabel>
                            <IonButton
                                fill="clear"
                                onClick={() => {
                                    dispatch(setPreselectLocation(location));
                                }}
                                size="large"
                            >
                                <IonIcon icon={addCircleOutline} />
                            </IonButton>
                        </IonItem>
                    ))}
                    {state.findLocationStatus === "pending" && (
                        <p className="ion-text-center">
                            <IonSpinner />
                        </p>
                    )}
                </IonList>
                <IonInfiniteScroll onIonInfinite={loadData} threshold="10px" disabled={isInfiniteDisabled}>
                    <IonInfiniteScrollContent loadingSpinner="bubbles" loadingText="Cargando más datos..." />
                </IonInfiniteScroll>
            </IonContent>
        </IonCard>
    );
};